export default "__VITE_ASSET__DR_YF0Az__"